import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=89dce40a"
import script from "./image-viewer.vue?vue&type=script&lang=js"
export * from "./image-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89dce40a')) {
      api.createRecord('89dce40a', component.options)
    } else {
      api.reload('89dce40a', component.options)
    }
    module.hot.accept("./image-viewer.vue?vue&type=template&id=89dce40a", function () {
      api.rerender('89dce40a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YLImage/image-viewer.vue"
export default component.exports